export default __webpack_public_path__ + "static/media/app-install.5ad90221.svg";